export enum CompanyType {
  Company = 'company',
  Proprietorship = 'proprietorship',
}
